var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',{staticClass:"progress-wrapper"},[_c('div',{staticClass:"progress-container"},[_c('v-progress-circular',{attrs:{"rotate":360,"size":80,"width":10,"value":_vm.progress,"color":"#967adc"}},[_vm._v(" "+_vm._s(_vm.progress)+"% ")])],1),_c('p',[_vm._v(_vm._s(_vm.statusMessage))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }